<template>
    <div>
        <Preloader v-if="isLoading" />
        <router-view v-slot="{ Component }">
            <transition
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
                mode="out-in"
                :duration="600"
                @after-leave="$root.$emit('triggerScroll')"
            >
                <component :is="Component" />
            </transition>
    </router-view>
        <GoTop />
        <CookieBanner />
    </div>
</template>

<script>
import Preloader from './components/Layouts/Preloader';
import GoTop from './components/Layouts/GoTop';
import CookieBanner from './components/Common/CookieBanner';
import AOS from 'aos';

export default {
    name: 'App',
    components: {
        Preloader,
        GoTop,
        CookieBanner,
    },
    data() {
        return {
            isLoading: true
        }
    },
    mounted() {
        setTimeout(() => {
            this.isLoading = false;
            this.$nextTick(() => {
                AOS.init({
                    duration: 800,
                    easing: 'ease-in-out',
                    once: false,
                });
            });
        }, 1500)
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                AOS.refresh();
            });
        }
    }
}
</script>